import { translate } from '../../../../../common/i18n';
import { insideTrade } from '../../relationChecker';

Blockly.Blocks.virtual_config = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Virtual Trades Settings'));
        this.appendValueInput('STATUS')
            .setCheck('Boolean')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Status')}:`);
        this.appendValueInput('TOKEN')
            .setCheck('String')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Demo Account Token')}:`);
        this.appendValueInput('MAXSTEPS')
            .setCheck('Number')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Max Steps')}:`);
        this.appendValueInput('STEPSCOUNT')
            .setCheck('Boolean')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Count steps on loss')}:`);
        this.appendValueInput('RESETTYPE')
            .setCheck('Boolean')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Reset steps')}:`);
        this.appendValueInput('MINREAL')
            .setCheck('Number')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Min. Trades on Real')}:`);
        this.appendValueInput('MAXREAL')
            .setCheck('Number')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Max. Trades on Real')}:`);
        this.appendValueInput('BACKREAL')
            .setCheck('Boolean')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Go Back to Virtual on Win')}:`);
        this.setColour('#f2f2f2');
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setTooltip(translate('Set all the virtual trades configuration'));
    },
    onchange: function onchange(ev) {
        insideTrade(this, ev, translate('Trade Options'));
    },
};

Blockly.JavaScript.virtual_config = block => {
    const status = Blockly.JavaScript.valueToCode(block, 'STATUS', Blockly.JavaScript.ORDER_ATOMIC);
    const token = Blockly.JavaScript.valueToCode(block, 'TOKEN', Blockly.JavaScript.ORDER_ATOMIC);
    const maxSteps = Blockly.JavaScript.valueToCode(block, 'MAXSTEPS', Blockly.JavaScript.ORDER_ATOMIC);
    const stepsCount = Blockly.JavaScript.valueToCode(block, 'STEPSCOUNT', Blockly.JavaScript.ORDER_ATOMIC);
    const resetType = Blockly.JavaScript.valueToCode(block, 'RESETTYPE', Blockly.JavaScript.ORDER_ATOMIC);
    const minReal = Blockly.JavaScript.valueToCode(block, 'MINREAL', Blockly.JavaScript.ORDER_ATOMIC);
    const maxReal = Blockly.JavaScript.valueToCode(block, 'MAXREAL', Blockly.JavaScript.ORDER_ATOMIC);
    const backReal = Blockly.JavaScript.valueToCode(block, 'BACKREAL', Blockly.JavaScript.ORDER_ATOMIC);
    const code = `
BinaryBotPrivateVirtualSettings = {
    token: ${token},
    ongoing: true,
    valid: true,
    changeToVirtual: false,
    changeToReal: false,
    steps: 0,
    realSteps:0, 
    countOnLoss: ${stepsCount},
    minTradesOnReal: ${minReal},
    maxTradesOnReal: ${maxReal},
    goBack: ${backReal},
    active: ${status},
    maxSteps: ${maxSteps},
    reset: ${resetType}
};`;

    return code;
};



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/virtualconfig.js